import {Injectable} from "@angular/core";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {EConfigurationActions, LoadConfigurationForHost, LoadConfigurationSuccess} from "../../actions/configuration/configuration.actions";
import {switchMap, withLatestFrom} from "rxjs/operators";
import {defaultConfiguration, IConfiguration} from "../../state/configuration/configuration.state";
import {of} from "rxjs";
import {CONFIGURATION_BORJOMI_DEV, CONFIGURATION_BORJOMI_PROD} from "../../state/configuration/host-configurations/conf-borjomi";
import {CONFIGURATION_RENAISSANCE_DEV, CONFIGURATION_RENAISSANCE_PROD} from "../../state/configuration/host-configurations/conf-renaissance";
import {CONFIGURATION_FRONERI_DEV, CONFIGURATION_FRONERI_PROD} from "../../state/configuration/host-configurations/conf-froneri";
import {CONFIGURATION_UNICREDIT_DEV, CONFIGURATION_UNICREDIT_PROD} from "../../state/configuration/host-configurations/conf-unicredit";
import {CONFIGURATION_AUCHAN_RO_ADMIN_INTERNAL, CONFIGURATION_AUCHAN_RO_CLIENT_EXTERNAL, CONFIGURATION_AUCHAN_RO_CLIENT_INTERNAL} from "../../state/configuration/host-configurations/conf-auchan-ro";
import {CONFIGURATION_AUCHAN_UA_ADMIN_INTERNAL, CONFIGURATION_AUCHAN_UA_CLIENT_EXTERNAL, CONFIGURATION_AUCHAN_UA_CLIENT_INTERNAL} from "../../state/configuration/host-configurations/conf-auchan-ua";
import {CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL, CONFIGURATION_AUCHAN_RU_CLIENT_EXTERNAL, CONFIGURATION_AUCHAN_RU_CLIENT_INTERNAL, CONFIGURATION_AUCHAN_RU_CLIENT_INTERNAL_WITH_DNS} from "../../state/configuration/host-configurations/conf-auchan-ru";
//import {CONFIGURATION_LOCALHOST, CONFIGURATION_LOCALHOST_REPLACE_HOST} from "../../../../localhost-configuration";
import {CONFIGURATION_REDFACTORY_DEV, CONFIGURATION_REDFACTORY_PROD} from "../../state/configuration/host-configurations/conf-redfactory";
import {CONFIGURATION_VERNIY_DEV} from "../../state/configuration/host-configurations/conf-verniy";
import {ConfigurationManager} from "../../../configuration-manager/configuration-manager";
import {
  CONFIGURATION_ACTION_DEV,
  CONFIGURATION_ACTION_PROD
} from "../../state/configuration/host-configurations/conf-action";
import {CONFIGURATION_PILOT_VRS_DEV, CONFIGURATION_PILOT_VRS_PROD} from "../../state/configuration/host-configurations/conf-vrs";


@Injectable()
export class ConfigurationEffects {
  LoadConfigurationForHost$ =  createEffect(() => this._actions$.pipe(
    ofType<LoadConfigurationForHost>(EConfigurationActions.LoadConfigurationForHost),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) =>{

      let configuration:IConfiguration = {...defaultConfiguration};
      switch(action.payload.host) {

        case 'action-dev.redfactory.io':
          configuration = CONFIGURATION_ACTION_DEV;
          break;

        case 'action-test.redfactory.io':
          configuration = CONFIGURATION_ACTION_PROD;
          break;

        case 'action.redfactory.io':
          configuration = CONFIGURATION_ACTION_PROD;
          break;

        case 'demo-dev.redfactory.io':
          configuration = CONFIGURATION_REDFACTORY_DEV;
          break;

        case 'portal-dev.redfactory.io':
          configuration = CONFIGURATION_REDFACTORY_DEV;
          break;

        case 'demo.redfactory.io':
          configuration = CONFIGURATION_REDFACTORY_PROD;
          break;

        case 'portal.redfactory.io':
          configuration = CONFIGURATION_REDFACTORY_PROD;
          break;
        case 'portal-test.redfactory.io':
          configuration = CONFIGURATION_REDFACTORY_PROD;
          break;

        case 'borjomi-dev.redfactory.io':
          configuration = CONFIGURATION_BORJOMI_DEV;
          break;
        case 'borjomi-test.redfactory.io':
          configuration = CONFIGURATION_BORJOMI_PROD;
          break;
        case 'borjomi.redfactory.io':
          configuration = CONFIGURATION_BORJOMI_PROD;
          break;

        case 'renaissance-dev.redfactory.io':
          configuration = CONFIGURATION_RENAISSANCE_DEV;
          break;

        case 'renaissance-test.redfactory.io':
          configuration = CONFIGURATION_RENAISSANCE_PROD;
          break;

        case 'renaissance.redfactory.io':
          configuration = CONFIGURATION_RENAISSANCE_PROD;
          break;

        case 'froneri-dev.redfactory.io':
          configuration = CONFIGURATION_FRONERI_DEV;
          break;
        case 'froneri.redfactory.io':
          configuration = CONFIGURATION_FRONERI_PROD;
          break;

        case 'unicredit-dev.redfactory.io':
          configuration = CONFIGURATION_UNICREDIT_DEV;
          break;
        case 'unicredit.redfactory.io':
          configuration = CONFIGURATION_UNICREDIT_PROD;
          break;

        case 'pilot-vrs-dev.redfactory.io':
          configuration = CONFIGURATION_PILOT_VRS_DEV;
          break;
        case 'pilot-vrs.redfactory.io':
          configuration = CONFIGURATION_PILOT_VRS_PROD;
          break;

//******************************************* Feature
        case 'dev01.redfactory.io':
          configuration = CONFIGURATION_REDFACTORY_DEV;
          break;
        case 'dev02.redfactory.io':
          configuration = CONFIGURATION_PILOT_VRS_DEV;
          break;
        case 'dev03.redfactory.io':
          configuration = CONFIGURATION_ACTION_DEV;
          break;

//******************************************* Ашан Румыния

          //Ашан румыния админ внутри
        case '10.147.170.86':
          configuration = CONFIGURATION_AUCHAN_RO_ADMIN_INTERNAL;
          break;
          //Ашан румыния клиент внутри
        case '10.147.170.87':
          configuration = CONFIGURATION_AUCHAN_RO_CLIENT_INTERNAL;
          break;
          //Ашан румыния клиент снаружи
        case 'extranet.auchan.ro':
          configuration = CONFIGURATION_AUCHAN_RO_CLIENT_EXTERNAL;
          break;


//******************************************* Ашан Украина Прод
        //Ашан украина админ прод внутри
        case '10.147.170.94':
          configuration = CONFIGURATION_AUCHAN_UA_ADMIN_INTERNAL;
          break;
        //Ашан украина админ прод внутри
        case 'ex-admin.awah-ua.ua.auchan.com':
          configuration = CONFIGURATION_AUCHAN_UA_ADMIN_INTERNAL;
          break;

          //Ашан украина клиент прод внутри
        case '10.147.170.93':
          configuration = CONFIGURATION_AUCHAN_UA_CLIENT_INTERNAL;
          break;
        //Ашан украина клиент прод внутри
        case 'ex-client.awah-ua.ua.auchan.com':
          configuration = CONFIGURATION_AUCHAN_UA_CLIENT_INTERNAL;
          break;


        //Ашан украина клиент прод снаружи
        case 'extranet.auchan.ua':
          configuration = CONFIGURATION_AUCHAN_UA_CLIENT_EXTERNAL;
          break;


//******************************************* Ашан Украина препрод


        //Ашан украина админ пре-прод внутри
        case 'ex-preprod-admin.awah-ua.ua.auchan.com':
          configuration = CONFIGURATION_AUCHAN_UA_ADMIN_INTERNAL;
          break;

        //Ашан украина клиент пре-прод внутри
        case 'ex-preprod-client.awah-ua.ua.auchan.com':
          configuration = CONFIGURATION_AUCHAN_UA_CLIENT_INTERNAL;
          break;

//******************************************* Ашан Украина тест
        //Ашан украина админ прод внутри
        case 'ex-test-admin.awah-ua.ua.auchan.com':
          configuration = CONFIGURATION_AUCHAN_UA_ADMIN_INTERNAL;
          break;
        //Ашан украина клиент прод внутри
        case 'ex-test-client.awah-ua.ua.auchan.com':
          configuration = CONFIGURATION_AUCHAN_UA_CLIENT_INTERNAL;
          break;


//******************************************* Ашан Россия
        //Ашан Россия админ внутри
        case '146.240.224.130':
          configuration = CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL;
          break;
        //Ашан Россия клиент внутри
        case '146.240.224.131':
          configuration = CONFIGURATION_AUCHAN_RU_CLIENT_INTERNAL;
          break;
        //Ашан Россия клиент снаружи
        case 'extranet.auchan.ru':
          configuration = CONFIGURATION_AUCHAN_RU_CLIENT_EXTERNAL;
          break;
          //Ашан Россия вф тест
          case '146.240.224.20':
            configuration = CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL;
            break;
          //Ашан Россия вф прод
          case '146.240.224.43':
            configuration = CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL;
            break;
          //Ашан Россия вф прод
          case 'wf':
            configuration = CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL;
            break;
          //Ашан Россия вф тест
          case 'wf-test':
            configuration = CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL;
            break;
          //Ашан Россия вф
          case 'wf.auchan.ru':
            configuration = CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL;
            break;
          //Ашан Россия вф
          case 'wf.domainru.ru.auchan.com':
            configuration = CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL;
            break;
          //Ашан Россия вф
          case 'wftest.domainru.ru.auchan.com':
            configuration = CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL;
            break;
          //Ашан Россия вф
          case 'wftest':
            configuration = CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL;
            break;
//******************************************* разработка

        case 'test01.redfactory.io':
          configuration = CONFIGURATION_REDFACTORY_PROD;
          break;
        case 'test02.redfactory.io':
          configuration = CONFIGURATION_REDFACTORY_PROD;
          break;
        case 'test03.redfactory.io':
          configuration = CONFIGURATION_REDFACTORY_PROD;
          break;

        case '10.77.16.27':
          configuration = CONFIGURATION_VERNIY_DEV;
          break;


        case 'portal.ru.auchan.com':
          configuration = CONFIGURATION_AUCHAN_RU_CLIENT_INTERNAL_WITH_DNS;
          break;


        //Демо для верного в румынии
        case '10.147.170.112':
          configuration = CONFIGURATION_VERNIY_DEV;
          configuration.api.protocol='http';
          break;

      }
      configuration.api.host = action.payload.host;
      configuration.api.port = action.payload.port;

      if (action.payload.host === 'localhost') {
        configuration = this.getConfigurationForLocalHost();
      }

      //Исправление проблемы по тикету case 38011
      if (action.payload.host === 'extranet.auchan.ru' && action.payload.protocol === 'https:') {
        configuration = CONFIGURATION_AUCHAN_RU_CLIENT_EXTERNAL;
      }
      if (action.payload.host === 'extranet.auchan.ru' && action.payload.protocol === 'http:') {
        configuration = CONFIGURATION_AUCHAN_RU_ADMIN_INTERNAL;
      }


      if (action.payload.host === 'ex-test-admin.awah-ua.ua.auchan.com' || action.payload.host === 'ex-admin.awah-ua.ua.auchan.com' || action.payload.host === 'ex-test-client.awah-ua.ua.auchan.com') {
        configuration.api.protocol = 'https';
        configuration.api.port = '443';
      }


      configuration.api.host = action.payload.host === 'localhost'?this.configurationManager.localHostReplaceHost: action.payload.host;

      return of(new LoadConfigurationSuccess({configuration: configuration}));
      }
    )
  ));

  getConfigurationForLocalHost():IConfiguration {
    return this.configurationManager.getLocalhostConfiguration();
  }

  constructor(
    private _actions$: Actions,
    private configurationManager: ConfigurationManager,
    private _store$: Store<IAppState>
  ) {
  }
}
